// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Modal';




// WEBPACK FOOTER //
// ./components/Modal/index.js